import React from "react";
import { LegalLayout, LegalSection, LegalTable } from "../components/LegalLayout";
import { COMPANY } from "../lib/constants";

const SECTIONS = [
  { id: "table", label: "How each service is delivered" },
  { id: "service-area", label: "Service area" },
  { id: "hardware", label: "Hardware" },
  { id: "delays", label: "Delays" },
];

const ROWS = [
  ["Atikxzio HMS plan", "Login access for the Owner by email (and WhatsApp when available)", "Within 2 working days of payment and account approval"],
  ["Setup & onboarding", "Configuration and data migration online; training online or at your hospital", "Scheduled with you; usually completed within 7 to 14 working days"],
  ["Credits", "Added to your account balance", "Instantly after online payment; bank transfers within 1 working day of receipt"],
  ["Add-ons", "Switched on in your account", "Within 1 working day of payment"],
  ["Invoices and receipts", "Email and download from your account", "Immediately after payment"],
];

export default function ShippingPolicy() {
  return (
    <LegalLayout
      title="Shipping &amp; Delivery Policy"
      sections={SECTIONS}
      seo={{
        title: "Shipping & Delivery Policy | Priyajit Systems Private Limited",
        description: "Priyajit Systems sells software services only. How and when Atikxzio HMS access, onboarding, credits, add-ons and invoices are delivered online across India.",
      }}
    >
      <p className="text-[17px] leading-[1.75] text-slate-700">
        We sell software services only; nothing is shipped physically, and every service is delivered online within the times below.
      </p>

      <LegalSection id="table" heading="How each service is delivered">
        <LegalTable head={["Service", "How it is delivered", "When"]} rows={ROWS} testId="shipping-table" />
      </LegalSection>

      <LegalSection id="service-area" heading="Service area.">
        <p>We serve organisations across India. On-site training is currently offered in Uttar Pradesh; elsewhere it is online.</p>
      </LegalSection>

      <LegalSection id="hardware" heading="Hardware.">
        <p>We do not ship printers, scanners or computers. An optional ward kit (tablet, QR printer, labels) can be arranged at cost + 20% and is delivered by the seller directly; we tell you the seller and delivery time before you pay.</p>
      </LegalSection>

      <LegalSection id="delays" heading="Delays.">
        <p>If access is not delivered in the time above, email {COMPANY.email} or call {COMPANY.phone}. If we cannot deliver, you get a full refund under our Refund &amp; Cancellation Policy.</p>
      </LegalSection>
    </LegalLayout>
  );
}
